<template>
  <div>
    <el-page-header class="detail-head" @back="goBack">
      <template v-slot:content>
        <div class="toolbar">
          <span>服务器详情</span>
          <div class="toolbar-items">
            <el-button size="mini" type="success" @click="test">测试连接</el-button>
          </div>
        </div>
      </template>
    </el-page-header>

    <el-divider class="detail-divider"></el-divider>

    <el-tabs model-value="first">
      <el-tab-pane label="基础信息" name="first">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="100px">
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="服务器编码" class="detail-form-item" prop="name">
                      <el-input size="medium" v-model="entity.code"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="服务器名称" class="detail-form-item">
                      <el-input size="medium" v-model="entity.name"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="类型" class="detail-form-item" prop="type">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.type">
                        <el-option v-for="item in types" :key="item.itemKey" :label="item.itemValue"
                          :value="item.itemKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="状态" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.state">
                        <el-option v-for="item in states" :key="item.itemKey" :label="item.itemValue"
                          :value="item.itemKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="服务接口名称" class="detail-form-item">
                      <el-input size="medium" v-model="entity.serviceName"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="IP地址" class="detail-form-item" prop="name">
                      <el-input size="medium" v-model="entity.ip"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="端口" class="detail-form-item">
                      <el-input size="medium" v-model="entity.port"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="grid-content">
                    <el-form-item label="备注" class="detail-form-item">
                      <el-input type="textarea" rows="5" v-model="entity.remark"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.creator" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="配置项列表" name="second">
        <div class="detail-containe-product">
          <el-form class="detail-form" :model="entity" label-width="100px">
            <div style="margin-bottom: 10px;">
              <el-button size="mini" type="danger" @click="addRow">增行</el-button>
            </div>
            <el-table :data="entity.serverConfigs" border style="width: 100%" max-height="520" @row-click="rowClick">
              <el-table-column prop="no" label="序号" width="50"> </el-table-column>
              <el-table-column prop="application" label="服务名" width="200">
                <template #default="scope">
                  <div v-if="scope.row.edit">
                    <input v-model.lazy="scope.row.application" class="el-input__inner input-row-edit" />
                  </div>
                  <div v-else>
                    {{ scope.row.application }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="configKey" label="配置项名称" width="360">
                <template #default="scope">
                  <div v-if="scope.row.edit">
                    <input v-model.lazy="scope.row.configKey" class="el-input__inner input-row-edit" />
                  </div>
                  <div v-else>
                    {{ scope.row.configKey }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="configValue" label="配置项值">
                <template #default="scope">
                  <div v-if="scope.row.edit">
                    <input v-model.lazy="scope.row.configValue" class="el-input__inner input-row-edit" />
                  </div>
                  <div v-else>
                    {{ scope.row.configValue }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="label" label="标签" width="100">
                <template #default="scope">
                  <div v-if="scope.row.edit">
                    <input v-model.lazy="scope.row.label" class="el-input__inner input-row-edit" />
                  </div>
                  <div v-else>
                    {{ scope.row.label }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="profile" label="前缀" width="100">
                <template #default="scope">
                  <div v-if="scope.row.edit">
                    <input v-model.lazy="scope.row.profile" class="el-input__inner input-row-edit" />
                  </div>
                  <div v-else>
                    {{ scope.row.profile }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="100">
                <template #default="scope">
                  <el-button size="mini" type="danger" @click="deleteRow(scope)">删行</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>

</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import { ServiceContext } from "@/script/core/base/ServiceData";
import { ElMessage, ElNotification } from "element-plus";
import { createServerContext } from "@/script/apps/device/config/DeviceConfig";
import { Server, ServerConfig } from "@/script/apps/device/entity/DeviceEntity";
import { ServerService } from "@/script/apps/device/service/ServerService";

@Options({})
export default class ServerDetail extends BaseDetail {
  public initData(): ServiceContext {
    return createServerContext();
  }

  public newEntity() {
    const entity: Server = {};
    return entity;
  }

  public afterLoad(data: any) {
    const server = this.entity as Server;
    server.deleteServerConfigs = [];
    this.injectDetailData(server.serverConfigs!, server.deleteServerConfigs!);
    this.generateRowNo();
  }

  public test() {
    (createServerContext().service as ServerService).test((data: string) => {
      ElMessage({ type: "success", message: "连接成功" });
    });
  }

  public addRow() {
    const server = this.entity as Server;
    const serverConfig: ServerConfig = {};
    serverConfig.application = server.serviceName;
    serverConfig.label = "master";
    serverConfig.profile = "dev";
    this.addListRow(server.serverConfigs!, serverConfig);
  }
}
</script>

<style lang="scss">
</style>
